import { create } from "zustand";

/**
 * Whether the current page wants the dark iOS 26 Safari top/bottom bar tint.
 *
 * The room/editor pages (PlayerPage, EditorPage) flip this on when they mount,
 * so the tint (<SafariBarTint>, rendered in App.js) covers EVERY room URL shape
 * — root-level slugs like /wasted, /play/:id, /player/:id, and /editor/* — not
 * just the path prefixes App.js used to match. Real published rooms open at
 * /:slug, which the old `startsWith("/player/")` check never caught, so their
 * bars stayed white.
 */
export const useSafariBarStore = create((set) => ({
  active: false,
  setActive: (active) => set({ active }),
}));
